// extracted by mini-css-extract-plugin
export default {"Gallery":"styles_Gallery__-m3jG","container":"styles_container__wSyt2","firstCol":"styles_firstCol__OsQhg","secondCol":"styles_secondCol__GxNkO","thirdCol":"styles_thirdCol__zFK4l"};